"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreNames = void 0;
var StoreNames;
(function (StoreNames) {
    StoreNames["Timecard"] = "Timecard";
    StoreNames["User"] = "User";
    StoreNames["Employment"] = "Employment";
})(StoreNames || (exports.StoreNames = StoreNames = {}));
